// AUTHENTICATION
export const CHECK_USER_INFO = 'CHECK_USER_INFO';
export const LOGOUT = 'LOGOUT';
export const SET_USER_INFO = 'SET_USER_INFO';
export const LOAD_TKN_INFO = 'LOAD_TKN_INFO';
export const CHANGE_TAB = 'CHANGE_TAB';
export const SET_USER_SUBS = 'SET_USER_SUBS';
